function About()
{
    return(
        <section id="about">
            <h2> About Me</h2>
            <p>Hi,I am Uma Rajagopal frontend and Wordpress developer skilled in React,node.js. I built clean responsive website

            </p>
        </section>
    );
}export default About;
